export {};

type NetworkState = 'loading' | 'success' | 'error';

const minSpeedMbps = 8;
const downloadSizeBytes = 5616998;
const speedTestImage = 'https://imgres.24ur.com/media/images/original/Apr2012/60908460.jpg';

function setRowState(row: string, state: NetworkState): void {
    const element = app.html.q(`[data-network-row="${row}"]`);
    if (!element) {
        return;
    }

    app.html.removeClass(element, 'is-loading is-success is-error');
    app.html.addClass(element, 'is-' + state);

    app.html.qAll('[data-network-icon-state]', element).forEach(icon => {
        app.html.toggleClassIf(icon, icon.getAttribute('data-network-icon-state') !== state, 'hidden');
    });
}

function showOnlyProfileMessage(value: 'guest' | 'subscribed' | 'unsubscribed'): void {
    app.html.qAll('[data-network-profile-message]').forEach(element => {
        app.html.toggleClassIf(element, element.getAttribute('data-network-profile-message') !== value, 'hidden');
    });
}

function showOnlyProfileAction(value: 'login' | 'subscribe' | 'continue'): void {
    app.html.qAll('[data-network-profile-action]').forEach(element => {
        app.html.toggleClassIf(element, element.getAttribute('data-network-profile-action') !== value, 'hidden');
    });
}

function showOnlySpeedMessage(value: 'loading' | 'success' | 'error'): void {
    app.html.qAll('[data-network-speed-message]').forEach(element => {
        app.html.toggleClassIf(element, element.getAttribute('data-network-speed-message') !== value, 'hidden');
    });
}

function renderProfile(): void {
    const user = window.app?.user?.user;

    if (!user) {
        setRowState('profile', 'error');
        app.html.writeHTML('[data-network-profile-title]', '');
        showOnlyProfileMessage('guest');
        showOnlyProfileAction('login');
        return;
    }

    app.html.writeHTML('[data-network-profile-title]', user.email);

    setRowState('profile', user.isSubscribed ? 'success' : 'error');

    if (user.isSubscribed) {
        showOnlyProfileMessage('subscribed');
        showOnlyProfileAction('continue');
        return;
    }

    showOnlyProfileMessage('unsubscribed');
    showOnlyProfileAction('subscribe');
}

function renderSpeed(speedMbps: number): void {
    const roundedSpeed = speedMbps.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    app.html.writeHTML('[data-network-speed-title]', `${roundedSpeed} Mbps`);
    setRowState('speed', speedMbps >= minSpeedMbps ? 'success' : 'error');
    showOnlySpeedMessage(speedMbps >= minSpeedMbps ? 'success' : 'error');
}

function getDownloadSpeed(times = 0, speedMbpsSum = 0): void {
    const image = new Image();
    const startTime = Date.now();

    image.onload = () => {
        const duration = Math.max((Date.now() - startTime) / 1000, 0.001);
        const bitsLoaded = downloadSizeBytes * 8;
        const speedBps = bitsLoaded / duration;
        const speedKbps = speedBps / 1024;
        const speedMbps = speedKbps / 1024;
        const nextTimes = times + 1;
        const nextSpeedMbpsSum = speedMbpsSum + speedMbps;

        if (nextTimes === 3) {
            renderSpeed(nextSpeedMbpsSum / nextTimes);
            return;
        }

        getDownloadSpeed(nextTimes, nextSpeedMbpsSum);
    };

    image.onerror = () => renderSpeed(0);
    image.src = speedTestImage + '?n=' + Math.random();
}

function renderGeo(): void {
    window.app.gql.geo()
        .then(geo => {
            setRowState('geo', 'success');
            app.html.writeHTML('[data-network-geo-title]', `${geo.countryName} - ${geo.countryCode} (${geo.ip})`);
            app.html.removeClass('[data-network-geo-news]', 'hidden');
        })
        .catch(() => {
            setRowState('geo', 'error');
            app.html.writeHTML('[data-network-geo-title]', '');
        });
}

function renderBrowser(): void {
    app.html.writeHTML('[data-network-browser-name]', config.device.model);
    app.html.writeHTML('[data-network-browser-version]', config.device.version);
    app.html.writeHTML('[data-network-browser-os]', config.device.os);
}

function initWhenAppReady(): void {
    if (!window.app) {
        setTimeout(initWhenAppReady, 25);
        return;
    }

    renderBrowser();
    getDownloadSpeed();
    renderProfile();
    renderGeo();

    document.addEventListener('started', renderProfile);
    document.addEventListener('started-user', renderProfile);
}

document.addEventListener('DOMContentLoaded', initWhenAppReady);
